import React from "react"
import { InternalHeaderContainer } from "./style"

const InternalHeader = ({ title, headerDescription, color, noLine }) => {
  return (
    <InternalHeaderContainer color={color} noLine={noLine}>
      <h1>
        <span dangerouslySetInnerHTML={{ __html: title }} />
      </h1>
      {headerDescription && (
        <p dangerouslySetInnerHTML={{ __html: headerDescription }} />
      )}
    </InternalHeaderContainer>
  )
}

export default InternalHeader
